import { onBeforeMount, onBeforeUnmount, readonly, Ref, ref } from 'vue'

export const useMediaDevices = (): Readonly<Ref<readonly MediaDeviceInfo[] | undefined>> => {
  const mediaDevices = ref<MediaDeviceInfo[] | undefined>(undefined)

  const updateMediaDevices = async (): Promise<void> => {
    mediaDevices.value = await navigator.mediaDevices.enumerateDevices()
  }

  onBeforeMount(() => {
    updateMediaDevices()
    navigator.mediaDevices.addEventListener('devicechange', updateMediaDevices)

    onBeforeUnmount(() =>
      navigator.mediaDevices.removeEventListener('devicechange', updateMediaDevices),
    )
  })

  return readonly(mediaDevices)
}
